import { normalizeCountry } from "../lib/industryFilter";

const CONTEXT_KEYS = [
  "context_type",
  "context_country",
  "context_sector",
  "context_industry",
];

/** Remove UI-only context_* keys before API calls (user app parity). */
export function stripContextKeys(metadata) {
  if (!metadata || typeof metadata !== "object") return {};
  const next = { ...metadata };
  for (const key of CONTEXT_KEYS) {
    delete next[key];
  }
  return next;
}

/**
 * Merge industry defaults into metadata for save/create.
 * When industry + country are set: CATEGORIES + stock_country; no ticker fields.
 */
export function applyIndustryDefaultsToMetadata(metadata, industryContext) {
  const base = stripContextKeys(metadata || {});
  const country = normalizeCountry(industryContext?.country);
  const industry = (industryContext?.industry || "").trim();

  if (industry && country) {
    base.stock_country = country;
    base.CATEGORIES = [industry];
    delete base.stock_ticker;
    delete base.stock_company_name;
  } else {
    delete base.CATEGORIES;
    delete base.stock_country;
  }

  return base;
}

export function hasIndustryDefaults(industryContext) {
  return Boolean(
    (industryContext?.industry || "").trim() &&
      normalizeCountry(industryContext?.country)
  );
}

export function isPartialIndustrySelection(industryContext) {
  const country = normalizeCountry(industryContext?.country);
  const sector = (industryContext?.sector || "").trim();
  const industry = (industryContext?.industry || "").trim();
  const any = Boolean(country || sector || industry);
  const complete = Boolean(country && sector && industry);
  return any && !complete;
}
